<template>
  <section v-if="faqItems.length" class="bg-white section-padding">
  <div class="container-full-width max-w-5xl">
    <div class="text-center">
      <span v-if="badge" class="badge">{{ badge }}</span>
      <h2 v-if="title" class="section-title mt-6">{{ title }}</h2>
      <p v-if="description" class="section-subtitle mx-auto">
        {{ description }}
      </p>
    </div>
    <div class="mt-12 grid gap-6 md:grid-cols-2">
      <article v-for="faq in faqItems" :key="faq.question" class="rounded-3xl border border-slate-100 bg-slate-25/60 p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-slate-900">{{ faq.question }}</h3>
          <p class="mt-3 text-sm leading-relaxed text-slate-500">{{ faq.answer }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
});

const sectionContent = computed(() => {
  if (Array.isArray(props.content)) {
    return { items: props.content };
  }
  return props.content || {};
});
const faqItems = computed(() =>
  (Array.isArray(sectionContent.value.items) ? sectionContent.value.items : []).filter(
    item => item?.question && item?.answer
  )
);
const badge = computed(() => sectionContent.value.badge || (faqItems.value.length ? 'Câu hỏi thường gặp' : ''));
const title = computed(() => sectionContent.value.title || (faqItems.value.length ? 'Mọi thắc mắc đều được giải đáp rõ ràng' : ''));
const description = computed(() => sectionContent.value.description || '');
</script>
